<!-- Titolo modale: usa l'interpolazione tramite translate con parametro number -->
<h2 mat-dialog-title>
  {{ 'handling.itemsDialog.title' | translate: { number: data.handlingNumber } }}
</h2>

<mat-dialog-content class="handling-items-dialog-content">

  <!-- Messaggio fallback se non ci sono articoli -->
  <p *ngIf="!data.itemHandlings?.length" class="no-items-message">
    {{ 'handling.itemsDialog.noItems' | translate }}
  </p>

  <!-- Label "Lista articoli" sopra la tabella -->
  <p *ngIf="data.itemHandlings?.length" class="items-list-label">
    {{ 'handling.itemsDialog.itemsList' | translate }}
  </p>

  <!-- Tabella stilizzata come la datatable padre -->
  <div *ngIf="data.itemHandlings?.length" class="table-wrapper">

    <table mat-table [dataSource]="data.itemHandlings" class="handling-items-table">

      <!-- Colonna: Codice articolo -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'handling.itemsDialog.col.code' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Item?.Code ?? '-' }}</td>
      </ng-container>

      <!-- Colonna: Nome articolo -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'handling.itemsDialog.col.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Item?.Name ?? '-' }}</td>
      </ng-container>

      <!-- Colonna: Descrizione articolo -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'handling.itemsDialog.col.description' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Item?.Description ?? '-' }}</td>
      </ng-container>

      <!-- Colonna: Codice opzionale articolo (AdditionalCode) -->
      <ng-container matColumnDef="additionalCode">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'handling.itemsDialog.col.additionalCode' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Item?.AdditionalCode ?? '-' }}</td>
      </ng-container>

      <!-- Colonna: Totale (Price * Qty o StartQty in base a HandlingState, logica BE) -->
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef class="col-numeric">
          {{ 'handling.itemsDialog.col.price' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="col-numeric">
  {{ getItemTotal(row) !== null ? (getItemTotal(row)! | formatPrice) : '-' }}
        </td>
      </ng-container>

      <!-- Colonna: Totale x 1000 (Totale * 1000, formattato con 2 decimali) -->
      <!-- <ng-container matColumnDef="price1000">
        <th mat-header-cell *matHeaderCellDef class="col-numeric">
          {{ 'handling.itemsDialog.col.price1000' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="col-numeric">
          {{ getItemTotal(row) !== null ? getItemTotal(row)! * 1000  : '-' }}
        </td>
      </ng-container> -->

      <!-- Colonna: Quantità -->
      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef class="col-numeric">
          {{ 'handling.itemsDialog.col.qty' | translate }}
        </th>
        <td mat-cell *matCellDef="let row" class="col-numeric">
          {{ row.Qty ?? '-' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </div>

</mat-dialog-content>

<!-- Footer con pulsante di chiusura allineato a destra -->
<mat-dialog-actions align="end">
  <ct-button [configuration]="closeButton"></ct-button>
</mat-dialog-actions>
